var React = require('react');

function Print (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"m6 5c0-.55228.44772-1 1-1h10c.5523 0 1 .44772 1 1v3h2c.5523 0 1 .44772 1 1v8c0 .5523-.4477 1-1 1h-2v2c0 .5523-.4477 1-1 1h-10c-.55228 0-1-.4477-1-1v-2h-2c-.55228 0-1-.4477-1-1v-8c0-.55228.44772-1 1-1h2zm10.5 9.5h-9v4.5c0 .2761.22386.5.5.5h8c.2761 0 .5-.2239.5-.5zm-8.5-9c-.27614 0-.5.22386-.5.5v2h9v-2c0-.27614-.2239-.5-.5-.5zm-3 5.25c0-.4142.33579-.75.75-.75h.5c.41421 0 .75.3358.75.75s-.33579.75-.75.75h-.5c-.41421 0-.75-.3358-.75-.75zm4.75 5.25c-.41421 0-.75.3358-.75.75s.33579.75.75.75h4.5c.4142 0 .75-.3358.75-.75s-.3358-.75-.75-.75z","fill":"#04c","fillRule":"evenodd"}));
}

Print.defaultProps = {"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Print;

Print.default = Print;
